import React from 'react'
import { connect } from 'react-redux'
import Label from 'components/Luxkit/Label/Label'
import styled from 'styled-components'
import Caption from 'components/Luxkit/Typography/Caption'
import LuxuryPlusLogo from './LuxuryPlusLogo'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import { isLuxuryPlusEnabled } from 'loyalty/selectors/featureToggle'
import cn from 'clsx'
import { rem } from 'polished'

const LabelElement = styled(Label)`
  background-color: ${props => props.theme.palette.product.loyalty};
  color: ${props => props.theme.palette.neutral.eight};
  border-color: ${props => props.theme.palette.product.loyalty}!important;

  &.size-small {
    height: ${rem(20)};
  }
`

interface MappedProps {
  isLuxuryPlusEnabled: boolean;
}

export type LuxPlusLabelTypes = 'insurance-discount' | 'extra-inclusions' | 'extra-inclusions-for' | 'member' | 'discount' | 'extra-inclusions-with' | 'only-logo';
interface Props extends MappedProps{
  showInfoIcon?: boolean;
  type: LuxPlusLabelTypes;
  size?: 'small' | 'medium';
}

function LuxuryPlusLabel({ type, isLuxuryPlusEnabled, showInfoIcon, size = 'medium', ...rest }: Props) {
  const logoHeight = size === 'small' ? 8 : 10
  if (!isLuxuryPlusEnabled) return null
  return <LabelElement className={cn(`size-${size}`)} kind="tertiary" variant="grey" {...rest}>
    {type === 'insurance-discount' && <><Caption variant="medium" weight="bold">25% off insurance for</Caption> <LuxuryPlusLogo colourMode="dark" height={logoHeight} /></>}
    {type === 'extra-inclusions' && <><LuxuryPlusLogo colourMode="dark" height={logoHeight} /><Caption variant="medium" weight="bold">extra inclusions</Caption></>}
    {type === 'extra-inclusions-for' && <><Caption variant="medium" weight="bold">Extra inclusions for</Caption><LuxuryPlusLogo colourMode="dark" height={logoHeight} /></>}
    {type === 'extra-inclusions-with' && <><Caption variant="medium" weight="bold">Extra inclusions with</Caption><LuxuryPlusLogo colourMode="dark" height={logoHeight} /></>}
    {type === 'member' && <><LuxuryPlusLogo colourMode="dark" height={logoHeight} /> <Caption variant="medium" weight="bold">member</Caption></>}
    {type === 'only-logo' && <LuxuryPlusLogo colourMode="dark" height={logoHeight} />}
    {showInfoIcon && <LineInfoCircleIcon />}
  </LabelElement>
}

const mapStateToProps = (state: App.State) => ({
  isLuxuryPlusEnabled: isLuxuryPlusEnabled(state),
})

export default connect(mapStateToProps)(LuxuryPlusLabel)
